import { FIELDS } from '../graphql/queries/field';
import { useFetchItems } from './useFetchItems';
/**
 * Custom hook for fetching and managing fields.
 *
 * @param {UseFieldsProps} options - The options for the hook.
 * @param {string} options.clientId - The client ID.
 * @param {string} options.entityType - The entity type.
 * @param {string} options.code - The field code.
 * @param {string[]} options.codes - The field codes.
 * @param {boolean} options.includeInactive - Whether to include inactive fields.
 * @param {boolean} options.isActive - The field active state.
 * @param {searchText} options.searchText - The search text.
 * @returns {Object} - An object containing the fetched items, error, and loading state.
 */
export const useFields = ({ clientId, entityType, code, codes, includeInactive, isActive, searchText, }) => {
    const { items, error, loading } = useFetchItems({
        fetchQuery: FIELDS,
        dataProp: 'fields',
        skip: !clientId,
        spec: { clientId, entityType, code, codes, includeInactive, isActive, searchText },
    });
    return {
        items,
        error,
        loading,
    };
};
